import parse from "html-react-parser";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import config from "config";

export const ConnectionUploaderIssue = ({ uploadId }) => {
  const { getTextByKey, getLanguage } = useContent();

  return (
    <div className="uploader-connection-failed-container">
      {parse(
        getTextByKey("uploader-connection-failed-message")
          .replace(
            "#LinkToOldUploaderWithSessionID#",
            `${
              config.baseurl
            }/${getLanguage()}/UploadJumbomail.aspx?sid=${uploadId}`
          )
          .replace(
            "#supportLink#",
            `${
              config.baseurl
            }/${getLanguage()}/support/sending-files/internet-block`
          )
      )}
    </div>
  );
};
